import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  title: string
  text: string
  text2: string
  text3: string
  text4: string
}
export const PolicyLists: RouteInfo[] = [
  {
    title: 'What is the CHCC-PAC?',
    text:
      "The California Hispanic Chambers of Commerce Political Action Committee (CHCC-PAC) is a non-profit, non-partisan collaboration of Hispanic business and community leaders.  The PAC focuses on protecting the interests of Hispanic-owned and small businesses, job growth, and California's economic success.",
    text2:
      'Formed in 2007, the CHCC-PAC is closely aligned with the CHCC business policy interests from a political perspective.  The CHCC-PAC offers organized political action to the Hispanic and small business community.  Contributing to the CHCC-PAC provides a vehicle for like-minded individuals to pool their resources and significantly impact state and local campaigns.',
    text3:
      'The CHCC-PAC has prioritized educating, supporting, and electing state and local candidates who understand and support small businesses.  The PAC is committed to electing state and local candidates who advocate policies that ensure a friendly environment for small businesses to flourish, economic growth, and job creation.',
    text4: '',
  },
  {
    title: 'How the CHCC-PAC Works',
    text:
      'A separate entity from the California Hispanic Chambers of Commerce (CHCC), the CHCC-PAC was developed so that Hispanic-owned and small businesses could collectively impact state and local legislative campaigns.  The CHCC-PAC membership votes on supporting candidates, and the CHCC-PAC Board of Directors decide to whom funds will be distributed.',
    text2:
      "The CHCC-PAC focuses its efforts on business-friendly candidates and races at California's local and state levels. We anticipate additional influence with important State and Federal issues and Federal candidates.",
    text3:
      "The CHCC-PAC contributes to candidates based on their past and continuing support of the Hispanic and small business community's agenda and makes its final decisions to create a prosperous and robust economy for our members and the state and a better quality of life for all Californians.",
    text4:
      'In addition to support and fundraising events for specific candidates or issues, activities may include, but are not limited to, candidate and ballot measure endorsement and contributions, voter registration, get-out-the-vote drives, conducting polls, surveys, mailers, and other activities.',
  },
  {
    title: 'Why Should You Contribute to the CHCC-PAC?',
    text:
      'The CHCC-PAC supports elected officials who are committed to support the growth and development of Hispanic and small businesses and fight detrimental and harmful policies to business, economy, and job growth. The CHCC has defeated bills that have threatened small business livelihood and have supported bills that have created investment in our community.',
    text2:
      "The CHCC believes that the participation of Hispanic and Latino business owners is essential to the CHCC-PAC's success. CHCC-PAC accepts membership from the Hispanic business and small business community. Even if a particular legislative race is outside your area, the CHCC-PAC provides a unique opportunity for the entire Hispanic business community to work in concert to create a pro-small business majority throughout California and a crucial step toward California's economic recovery.",
    text3:
      'CHCC-PAC membership includes individuals and organizations that value-focused political representation of Hispanic Business interests and realize the importance of expressing their views via an aggregate voice like the CHCC-PAC.',
    text4: '',
  },
  {
    title: 'How Do You Contribute?',
    text:
      'Submit a <a href="https://www.efundraisingconnections.com/c/CHCCPAC" target="_blank"> contribution online</a> or contact the CHCC office at (916) 444-2221. Under California\'s campaign finance law, Proposition 34, individuals and companies can contribute up to $8,100 annually to a political action committee. Separately, per election, an individual or company may contribute $4,900 directly to a candidate.',
    text2:
      'CHCC-PAC contribution limit: $8,100 (ID #1287461). CHCC-PAC contributions are not tax-deductible as charitable contributions for federal income tax purposes.',
    text3: '',
    text4: '',
  },
]

@Component({
    selector: 'app-chccpac',
    templateUrl: './chccpac.component.html',
    styleUrls: ['./chccpac.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CHCCPacComponent implements OnInit {
  mainTitle = 'CHCC PAC'
  lists: any = []

  constructor() {}

  ngOnInit(): void {
    this.lists = PolicyLists.filter((list) => list)
  }
}
function innerHTML(arg0: string) {
  throw new Error('Function not implemented.')
}
